// extracted by mini-css-extract-plugin
export default {"widget":"styles_widget__-KLPR"};